(function () {
  'use strict';

  var S = Object.assign({
    close: 'Close',
    newWindow: 'Opens in a new window.',
    readMore: 'Read more',
    quantity: 'Quantity',
    pageTitle: document.title,
    shopName: ''
  }, window.a11yStrings || {});

  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  var VAGUE_LINK = /^(read more|learn more|shop now|view more|view details|more info)$/i;
  var PDF_LINK = /^download( the)? pdf$/i;
  var uid = 0;

  function ensureId(el, prefix) {
    if (!el.id) el.id = (prefix || 'a11y') + '-' + (++uid);
    return el.id;
  }

  function isVisible(el) {
    if (!el || !(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
    return getComputedStyle(el).visibility !== 'hidden';
  }

  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), isVisible);
  }

  function srOnly(text) {
    var span = document.createElement('span');
    span.className = 'yv-visually-hidden';
    span.setAttribute('data-a11y-text', '');
    span.textContent = text;
    return span;
  }

  function cleanText(el) {
    var clone = el.cloneNode(true);
    clone.querySelectorAll('[data-a11y-text], .yv-visually-hidden, .visually-hidden').forEach(function (n) { n.remove(); });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function markButton(el, label) {
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('data-a11y-btn', '');
    if (label) el.setAttribute('aria-label', label);
  }

  var live = null;
  var lastMessage = '';
  var lastMessageAt = 0;

  function announce(message) {
    if (!message) return;
    var now = Date.now();
    if (message === lastMessage && now - lastMessageAt < 500) return;
    lastMessage = message;
    lastMessageAt = now;
    if (!live) {
      live = document.createElement('div');
      live.className = 'yv-visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = message; }, 100);
  }

  // Drawers and pop-ups
  var DIALOGS = [
    { state: 'nav-open', sel: '#mobileMenu', label: 'Menu', first: '.close-btn' },
    { state: 'addsearch', sel: '.search-bar-container', label: 'Search', first: '#search-drawer-query-input' },
    { state: 'side_Drawer_open', sel: '[data-side-drawer]', title: '[data-drawer-title]', first: '.yv_side_drawer_close' },
    { state: 'similar_Drawer_open', sel: '[data-similar-product-drawer]', title: '.yv_similar_drawer_title h6', first: '.yv_similar_drawer_close' },
    { state: 'account-popup-open', sel: '[data-account-popup]', title: 'login', first: '#CustomerEmail' }
  ];

  var TRIGGERS = [
    { sel: '.navbar-toggler', state: 'nav-open', controls: '#mobileMenu' },
    { sel: '.search-form[data-search-drawer]', state: 'addsearch', controls: '.search-bar-container', popup: true },
    { sel: '#customer_login_link', state: 'account-popup-open', controls: '[data-account-popup]', popup: true }
  ];

  // Login opens a dialog only in popup mode; logged-in customers get a dropdown or the account page
  function opensDialog(t, el) {
    if (!t.popup) return false;
    if (el.id !== 'customer_login_link') return true;
    return /'popup'/.test(el.getAttribute('onclick') || '') && !!document.querySelector(t.controls);
  }

  var lastOutside = null;
  var openStack = [];

  function inDialog(el) {
    return DIALOGS.some(function (d) {
      var box = document.querySelector(d.sel);
      return box && box.contains(el);
    });
  }

  function visibleLoginTitle(box) {
    var forms = box.querySelectorAll('.yv-login-form');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].style.display !== 'none' && getComputedStyle(forms[i]).display !== 'none') return forms[i].querySelector('.form-title');
    }
    return null;
  }

  function initDialogs() {
    DIALOGS.forEach(function (d) {
      var box = document.querySelector(d.sel);
      if (!box) return;
      box.setAttribute('role', 'dialog');
      box.removeAttribute('aria-live');
      var title = d.title === 'login' ? visibleLoginTitle(box) : (d.title && box.querySelector(d.title));
      if (title) {
        box.setAttribute('aria-labelledby', ensureId(title, 'a11y-dialog-title'));
        box.removeAttribute('aria-label');
      } else if (d.label) {
        box.setAttribute('aria-label', d.label);
      }
    });

    TRIGGERS.forEach(function (t) {
      var target = document.querySelector(t.controls);
      document.querySelectorAll(t.sel).forEach(function (el) {
        if (target) el.setAttribute('aria-controls', ensureId(target, 'a11y-panel'));
        if (opensDialog(t, el)) {
          el.setAttribute('role', 'button');
          el.setAttribute('aria-haspopup', 'dialog');
          el.removeAttribute('aria-expanded');
        } else {
          el.setAttribute('aria-expanded', document.body.classList.contains(t.state) ? 'true' : 'false');
        }
        if (!el.getAttribute('aria-label') && el.getAttribute('title')) el.setAttribute('aria-label', el.getAttribute('title'));
        if (el.tagName === 'A' && el.getAttribute('role') === 'button') el.setAttribute('data-a11y-space', '');
      });
    });

    var closeBtn = document.querySelector('#mobileMenu .close-btn');
    if (closeBtn && closeBtn.getAttribute('tabindex') === '-1') {
      closeBtn.removeAttribute('tabindex');
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('data-a11y-space', '');
    }
    if (closeBtn) closeBtn.setAttribute('aria-label', S.close + ' menu drawer');

    document.querySelectorAll('.yv_side_drawer_close, .yv_similar_drawer_close').forEach(function (btn) {
      var drawer = btn.closest('[data-side-drawer], [data-similar-product-drawer]');
      var title = drawer && drawer.querySelector('[data-drawer-title], .yv_similar_drawer_title h6');
      var name = drawer && drawer.classList.contains('mini_cart') ? 'cart' : (title ? cleanText(title).toLowerCase() : '');
      var label = S.close + (name ? ' ' + name : '') + ' drawer';
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    });
  }

  function onBodyClass() {
    DIALOGS.forEach(function (d) {
      var open = document.body.classList.contains(d.state);
      if (open === !!d.open) return;
      d.open = open;
      var box = document.querySelector(d.sel);
      if (!box) return;

      if (open) {
        d.returnTo = lastOutside;
        openStack.push(d);
        box.setAttribute('aria-modal', 'true');
        setTimeout(function () {
          if (!d.open || box.contains(document.activeElement)) return;
          var target = d.first && box.querySelector(d.first);
          if (!isVisible(target)) target = focusables(box)[0];
          if (target) target.focus();
        }, 100);
      } else {
        openStack = openStack.filter(function (item) { return item !== d; });
        box.removeAttribute('aria-modal');
        var back = d.returnTo;
        d.returnTo = null;
        setTimeout(function () {
          var active = document.activeElement;
          var lost = !active || active === document.body || box.contains(active) || !isVisible(active);
          if (lost && back && document.contains(back) && isVisible(back)) back.focus();
        }, 100);
      }
    });

    TRIGGERS.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (el) {
        if (!opensDialog(t, el)) el.setAttribute('aria-expanded', document.body.classList.contains(t.state) ? 'true' : 'false');
      });
    });
  }

  function trapRoot() {
    var labelModal = document.querySelector('[data-label-modal]:not([hidden])');
    if (labelModal) return labelModal.querySelector('.product-label-viewer__dialog');
    var top = openStack[openStack.length - 1];
    return top ? document.querySelector(top.sel) : null;
  }

  function trapTab(event) {
    var root = trapRoot();
    if (!root || event.defaultPrevented) return;
    var items = focusables(root);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!root.contains(active)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && (active === first || active === root)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  // Login pop-up
  function initLogin() {
    var box = document.querySelector('[data-account-popup]');
    if (!box || box.hasAttribute('data-a11y-login')) return;
    box.setAttribute('data-a11y-login', '');
    box.querySelectorAll('label.hidden').forEach(function (label) {
      label.classList.remove('hidden');
      label.classList.add('yv-visually-hidden');
    });
    box.addEventListener('click', function (event) {
      var link = event.target.closest('[data-open]');
      if (!link) return;
      setTimeout(function () {
        var form = document.getElementById(link.getAttribute('data-open'));
        var title = form && form.querySelector('.form-title');
        if (title) {
          box.setAttribute('aria-labelledby', ensureId(title, 'a11y-dialog-title'));
          title.focus();
        }
      }, 50);
    });
  }

  // Main menu dropdowns
  function setMenu(menu, open) {
    if (open) {
      menu.setAttribute('open', '');
      menu.classList.add('open');
    } else {
      menu.removeAttribute('open');
      menu.classList.remove('open');
    }
  }

  function initMainMenu() {
    document.querySelectorAll('.a11y-nav .yv-dropdown-detail:not([data-a11y-menu])').forEach(function (menu) {
      menu.setAttribute('data-a11y-menu', '');
      var link = menu.querySelector('a.dropdown-menu-item');
      var btn = menu.querySelector('.a11y-menu-toggle');
      var panel = menu.querySelector('.yv-dropdown-menus-outer');
      if (!btn || !panel) return;
      btn.setAttribute('aria-controls', ensureId(panel, 'a11y-menu'));

      new MutationObserver(function () {
        btn.setAttribute('aria-expanded', menu.hasAttribute('open') ? 'true' : 'false');
      }).observe(menu, { attributes: true, attributeFilter: ['open'] });

      var open = function (state, focusFirst) {
        document.querySelectorAll('.a11y-nav .yv-dropdown-detail[open]').forEach(function (other) {
          if (other !== menu) setMenu(other, false);
        });
        setMenu(menu, state);
        if (state && focusFirst) {
          setTimeout(function () {
            var first = focusables(panel)[0];
            if (first) first.focus();
          }, 50);
        }
      };

      // The theme closes menus on body click, so apply the state after it
      var closedByClick = false;
      btn.addEventListener('click', function () {
        var state = !menu.hasAttribute('open');
        closedByClick = !state;
        setTimeout(function () { open(state); }, 0);
      });

            // Open on desktop hover; preserve click-to-close behavior.
      var hoverRoot = menu.parentElement || menu;

      function usesHoverMenu() {
        var header = menu.closest('header');
        return !!header &&
          header.getAttribute('data-naviation-open-method') === 'hover' &&
          window.matchMedia(
            '(min-width: 1025px) and (hover: hover) and (pointer: fine)'
          ).matches;
      }

      hoverRoot.addEventListener('mouseover', function () {
        if (closedByClick) {
          setMenu(menu, false);
          return;
        }

        if (usesHoverMenu()) open(true);
      });

      hoverRoot.addEventListener('mouseleave', function () {
        closedByClick = false;

        if (usesHoverMenu()) open(false);
      });

      btn.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        open(true, true);
      });

      if (link) {
        link.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          open(true, true);
        });

        // Link and arrow share one hover colour, as before
        [[link, btn], [btn, link]].forEach(function (p) {
          p[0].addEventListener('mouseenter', function () { p[1].style.color = getComputedStyle(p[0]).color; });
          p[0].addEventListener('mouseleave', function () { p[1].style.color = ''; });
        });
      }

      menu.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !menu.hasAttribute('open')) return;
        setMenu(menu, false);
        btn.focus();
      });

      var item = menu.closest('.nav-item') || menu;
      item.addEventListener('focusout', function (event) {
        if (event.relatedTarget && !item.contains(event.relatedTarget)) setMenu(menu, false);
      });
    });
  }

  function initMobileSubmenus() {
    document.querySelectorAll('#mobileMenu button.toggle, #mobileMenu button.toggle-level').forEach(function (btn) {
      if (btn.__a11y) return;
      btn.__a11y = true;
      var inner = btn.nextElementSibling && btn.nextElementSibling.classList.contains('inner') ? btn.nextElementSibling : btn.parentElement.querySelector(':scope > .inner');
      if (inner) btn.setAttribute('aria-controls', ensureId(inner, 'a11y-submenu'));
      var sync = function () { btn.setAttribute('aria-expanded', btn.classList.contains('open-menu-drop') ? 'true' : 'false'); };
      sync();
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // Landmarks and headings
  function initLandmarks() {
    var footer = document.querySelector('.a11y-footer-landmark footer');
    if (footer) footer.setAttribute('role', 'none');

    var mobileNav = document.querySelector('#mobileMenu #menu-view');
    if (mobileNav && !mobileNav.getAttribute('role')) {
      mobileNav.setAttribute('role', 'navigation');
      mobileNav.setAttribute('aria-label', 'Mobile');
    }

    // Footer column titles: h3 -> h2 (styles are class-based)
    document.querySelectorAll('h3[class^="ai-footer-menu-title-"], h3[class^="ai-footer-contact-title-"]').forEach(function (h) {
      var h2 = document.createElement('h2');
      Array.prototype.forEach.call(h.attributes, function (a) { h2.setAttribute(a.name, a.value); });
      while (h.firstChild) h2.appendChild(h.firstChild);
      h.parentNode.replaceChild(h2, h);
    });

    document.querySelectorAll('[class^="ai-footer-col-"], [class^="ai-footer-accordion-item-"]').forEach(function (col) {
      if (col.getAttribute('role') || !col.querySelector('[class^="ai-footer-menu-list-"]')) return;
      var title = col.querySelector('h2, h3, h4, [class^="ai-footer-accordion-button-"]');
      col.setAttribute('role', 'navigation');
      if (title) col.setAttribute('aria-labelledby', ensureId(title, 'a11y-footer-nav'));
    });
  }

  function fixHeadings() {
    document.querySelectorAll('[data-drawer-title], .yv_similar_drawer_title h6, [data-account-popup] .form-title, #filterHeading, .yv-product-accordion .yv-accordion-header > h6').forEach(function (h) {
      h.setAttribute('aria-level', '2');
    });

    var main = document.getElementById('MainContent');
    if (!main || main.querySelector('[data-a11y-h1]')) return;
    var hasH1 = Array.prototype.some.call(main.querySelectorAll('h1, [aria-level="1"]'), function (h) {
      return isVisible(h) || h.classList.contains('yv-visually-hidden');
    });
    if (hasH1) return;

    var productTitle = main.querySelector('.product-section .yv-product-detail-title, .yv-product-detail-title');
    if (productTitle && /^H[2-6]$/.test(productTitle.tagName)) {
      productTitle.setAttribute('aria-level', '1');
      productTitle.setAttribute('data-a11y-h1', '');
      return;
    }

    var h1 = document.createElement('h1');
    h1.className = 'yv-visually-hidden';
    h1.setAttribute('data-a11y-h1', '');
    h1.textContent = document.body.classList.contains('template_index') ? (S.shopName || S.pageTitle) : S.pageTitle;
    main.insertBefore(h1, main.firstChild);
  }

  // Promotional text read as separate items
  function splitPromo(source, insertAfter) {
    var items = source.textContent.split('·').map(function (t) { return t.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    if (items.length < 2) return;
    var list = document.createElement('ul');
    list.className = 'yv-visually-hidden';
    list.setAttribute('data-a11y-text', '');
    items.forEach(function (text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    });
    if (insertAfter) source.parentNode.insertBefore(list, source.nextSibling);
    else source.parentNode.insertBefore(list, source);
  }

  function initPromo() {
    document.querySelectorAll('.infinite-text-content:not([data-a11y-promo])').forEach(function (el) {
      el.setAttribute('data-a11y-promo', '');
      var first = el.querySelector('p');
      if (!first || el.querySelector(FOCUSABLE)) return;
      splitPromo(first, false);
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[class^="ai-text-block-content-"] p:not([data-a11y-promo])').forEach(function (p) {
      p.setAttribute('data-a11y-promo', '');
      if (p.textContent.indexOf('·') === -1 || p.querySelector(FOCUSABLE)) return;
      splitPromo(p, true);
      p.setAttribute('aria-hidden', 'true');
    });
  }

  // Tabs
  function syncTabs(list) {
    (list.__a11yTabs || []).forEach(function (t) {
      var selected = t.isActive();
      // Announce a newly selected tab after a user click / key
      if (list.__a11yUser && selected && t.tab.getAttribute('aria-selected') !== 'true') {
        list.__a11yUser = false;
        announce(cleanText(t.tab) + ' tab selected');
      }
      t.tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.tab.setAttribute('tabindex', selected ? '0' : '-1');
      if (selected && t.panel) t.panel.setAttribute('aria-labelledby', t.tab.id);
    });
  }

  function setupTablist(list, entries) {
    if (list.__a11yTabs || !entries.length) return;
    list.__a11yTabs = entries;
    list.setAttribute('role', 'tablist');
    entries.forEach(function (t) {
      t.tab.setAttribute('role', 'tab');
      ensureId(t.tab, 'a11y-tab');
      if (t.tab.tagName === 'A') t.tab.setAttribute('data-a11y-space', '');
      if (t.tab.parentElement.tagName === 'LI') t.tab.parentElement.setAttribute('role', 'presentation');
      if (t.panel) {
        t.panel.setAttribute('role', 'tabpanel');
        t.tab.setAttribute('aria-controls', ensureId(t.panel, 'a11y-tabpanel'));
      }
    });
    list.addEventListener('click', function () {
      list.__a11yUser = true;
      setTimeout(function () { syncTabs(list); list.__a11yUser = false; }, 50);
    });
    list.addEventListener('keydown', function (event) {
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;
      var tabs = entries.map(function (t) { return t.tab; }).filter(isVisible);
      var index = tabs.indexOf(event.target.closest('[role="tab"]'));
      if (index === -1) return;
      event.preventDefault();
      if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      tabs[index].focus();
      tabs[index].click();
    });
    syncTabs(list);
  }

  function initTabs() {
    var lists = [];
    document.querySelectorAll('li.yv-tab-item > .yv-tab-link').forEach(function (tab) {
      var list = tab.parentElement.parentElement;
      if (lists.indexOf(list) === -1) lists.push(list);
    });
    lists.forEach(function (list) {
      setupTablist(list, Array.prototype.map.call(list.querySelectorAll(':scope > li.yv-tab-item'), function (li) {
        var panel = null;
        if (li.getAttribute('data-nav')) panel = document.querySelector(li.getAttribute('data-nav'));
        else if (li.getAttribute('content')) panel = document.getElementById(li.getAttribute('content'));
        return { tab: li.querySelector('.yv-tab-link'), panel: panel, isActive: function () { return li.classList.contains('active'); } };
      }).filter(function (t) { return t.tab; }));
    });

    document.querySelectorAll('[class^="ai-tabbed-content-tabs-"]').forEach(function (list) {
      var root = list.parentElement;
      setupTablist(list, Array.prototype.map.call(list.querySelectorAll('button[data-tab]'), function (btn) {
        if (/^Tab \d+$/.test(btn.getAttribute('aria-label') || '')) btn.removeAttribute('aria-label');
        return {
          tab: btn,
          panel: root.querySelector('[data-panel="' + btn.getAttribute('data-tab') + '"]'),
          isActive: function () { return btn.classList.contains('active'); }
        };
      }));
    });

    lists.forEach(syncTabs);
  }

  // Accordions
  function syncAccordion(header) {
    (header.__a11yBtn || header).setAttribute('aria-expanded', header.classList.contains('active') ? 'true' : 'false');
  }

  function initAccordions() {
    document.querySelectorAll('.faqSection-header:not([data-a11y-acc])').forEach(function (header) {
      header.setAttribute('data-a11y-acc', '');
      // Button goes inside the heading (a heading inside role=button loses its heading role)
      var heading = header.querySelector('h1, h2, h3, h4, h5, h6');
      var btn = header;
      if (heading) {
        btn = document.createElement('span');
        btn.className = 'a11y-acc-btn';
        while (heading.firstChild) btn.appendChild(heading.firstChild);
        heading.appendChild(btn);
      }
      markButton(btn);
      header.__a11yBtn = btn;
      var panel = header.getAttribute('content') && document.getElementById(header.getAttribute('content'));
      if (panel) btn.setAttribute('aria-controls', panel.id);
      syncAccordion(header);
      new MutationObserver(function () { syncAccordion(header); }).observe(header, { attributes: true, attributeFilter: ['class'] });
      header.addEventListener('click', function () {
        var group = header.closest('.yv-faq-accordion') || document;
        setTimeout(function () { group.querySelectorAll('.faqSection-header').forEach(syncAccordion); }, 50);
      });
    });
  }

  // Blog card blocks: name each <article> after its post title
  function initBlogCards() {
    document.querySelectorAll('article[class^="ai-blog-"]:not([data-a11y-article])').forEach(function (article) {
      article.setAttribute('data-a11y-article', '');
      var heading = article.querySelector('h1, h2, h3, h4, h5, h6');
      var title = heading && cleanText(heading);
      if (title && !article.hasAttribute('aria-label')) article.setAttribute('aria-label', title);
    });
    // Blog page: section titles (styled <p>) read as H2 so the card H3s sit under them
    if (!document.querySelector('article[class^="ai-blog-card-"]')) return;
    document.querySelectorAll('[class^="ai-rich-text-header-"]:not([data-a11y-section])').forEach(function (header) {
      header.setAttribute('data-a11y-section', '');
      if (header.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"]')) return;
      var p = header.querySelector('p');
      if (!p || !cleanText(p)) return;
      p.setAttribute('role', 'heading');
      p.setAttribute('aria-level', '2');
    });
  }

  // Misc ARIA clean-ups from site scans
  function initScanFixes() {
    // Labelled generic containers need a role
    document.querySelectorAll('[class^="ai-footer-social-"][aria-label]:not([role])').forEach(function (el) {
      el.setAttribute('role', 'group');
    });
    // Embedded frames need a name
    document.querySelectorAll('iframe:not([title]):not([aria-label]):not([aria-hidden="true"])').forEach(function (frame) {
      var src = frame.getAttribute('src') || '';
      if (/docs\.google\.com\/forms/.test(src)) frame.setAttribute('title', 'Form: ' + S.pageTitle.split(/\s[–|-]\s/)[0]);
      else if (/youtube|vimeo/.test(src)) frame.setAttribute('title', 'Video');
      else if (src && !/preview-bar|web-pixels/.test(src)) frame.setAttribute('title', 'Embedded content');
    });
    // Disabled letter links (herbal A–Z): aria-disabled is not valid on links
    document.querySelectorAll('a[href][aria-disabled="true"]').forEach(function (a) {
      a.removeAttribute('aria-disabled');
      a.setAttribute('aria-hidden', 'true');
      a.setAttribute('tabindex', '-1');
    });
    document.querySelectorAll('[disabled][aria-disabled]').forEach(function (el) { el.removeAttribute('aria-disabled'); });
    // Cookie consent app: closed preferences panel is aria-hidden but its buttons stay tabbable
    document.querySelectorAll('csm-cookie-consent').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root || root.__a11yObserved) return;
      root.__a11yObserved = true;
      var sync = function () {
        root.querySelectorAll('[aria-hidden="true"]:not([data-a11y-inert])').forEach(function (el) {
          if (!el.querySelector(FOCUSABLE) || el.inert) return;
          el.inert = true;
          el.setAttribute('data-a11y-inert', '');
        });
        root.querySelectorAll('[data-a11y-inert]:not([aria-hidden="true"])').forEach(function (el) {
          el.inert = false;
          el.removeAttribute('data-a11y-inert');
        });
      };
      sync();
      new MutationObserver(sync).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    });
    // Empty headings in page/blog content (editor line breaks): keep the line, drop the heading
    document.querySelectorAll('.rich-editor-text-content :is(h1, h2, h3, h4, h5, h6)').forEach(function (h) {
      if (h.textContent.trim() || h.querySelector('img, svg, video, iframe')) return;
      var div = document.createElement('div');
      Array.prototype.forEach.call(h.attributes, function (attr) { div.setAttribute(attr.name, attr.value); });
      div.classList.add('heading-style', h.tagName.toLowerCase());
      while (h.firstChild) div.appendChild(h.firstChild);
      h.replaceWith(div);
    });
    // Empty corner header cell in content tables: a data cell, same look
    document.querySelectorAll('.rich-editor-text-content table th').forEach(function (th) {
      if (th.textContent.trim() || th.querySelector('img, svg')) return;
      var td = document.createElement('td');
      Array.prototype.forEach.call(th.attributes, function (attr) { td.setAttribute(attr.name, attr.value); });
      td.setAttribute('data-a11y-corner', '');
      th.replaceWith(td);
    });
    // Buttons on a dark block: the dark focus ring didn't show there
    document.querySelectorAll('[class^="ai-"][class*="-button-"]:not([data-a11y-ring]), [class^="ai-"][class*="-cta-"]:not([data-a11y-ring])').forEach(function (btn) {
      var bg = blockBackground(btn.parentElement);
      if (!bg) return; // styles not loaded yet; retried on next refresh
      btn.setAttribute('data-a11y-ring', contrastRatio(bg, [58, 44, 86]) < 3 ? 'light' : '');
    });
    // Judge.me reviews: text added only with CSS
    document.querySelectorAll('.jdgm-rev__buyer-badge:not([data-a11y-badge])').forEach(function (badge) {
      if (badge.textContent.trim()) return;
      var text = getComputedStyle(badge, '::before').content;
      if (!text || text === 'none' || text === 'normal') return; // styles not loaded yet; retried on next refresh
      badge.textContent = text.replace(/^["']|["']$/g, '');
      badge.setAttribute('data-a11y-badge', '');
    });
  }

  // First solid background behind an element, as [r, g, b]
  function blockBackground(el) {
    for (; el && el.nodeType === 1; el = el.parentElement) {
      var m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if (m && (m.length < 4 || +m[3] === 1)) return m.slice(0, 3).map(Number);
    }
    return null;
  }

  function contrastRatio(a, b) {
    var lum = function (rgb) {
      var c = rgb.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
      return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    };
    var x = lum(a), y = lum(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  }

  // Inline text links need more than colour (underline)
  function initInlineLinks() {
    document.querySelectorAll('main a[href]:not([data-a11y-inline-checked]), .a11y-footer-landmark a[href]:not([data-a11y-inline-checked])').forEach(function (a) {
      a.setAttribute('data-a11y-inline-checked', '');
      if (a.closest('nav, [role="navigation"], [class*="jdgm"], .klaviyo-form, [class*="button"], .button, [role="button"], [role="tab"], h1, h2, h3, h4, h5, h6')) return;
      if (a.querySelector('img, svg')) return;
      var c = getComputedStyle(a);
      if (c.display !== 'inline' || /underline/.test(c.textDecorationLine) || c.borderBottomStyle !== 'none') return;
      if (!a.textContent.trim()) return;
      // Only links inside running text: the paragraph has words outside its links
      var block = a.closest('p, li, td, dd, blockquote');
      // Page content can use <div> lines instead of <p> (Disclaimer page)
      if (!block && a.parentElement.tagName === 'DIV' && a.parentElement.closest('.rich-editor-text-content')) block = a.parentElement;
      if (!block) return;
      var rest = block.cloneNode(true);
      rest.querySelectorAll('a, [data-a11y-text], .yv-visually-hidden, .visually-hidden, [aria-hidden="true"]').forEach(function (n) { n.remove(); });
      if (!/[A-Za-z]{2,}/.test(rest.textContent)) return;
      if (c.color === getComputedStyle(block).color && c.fontWeight === getComputedStyle(block).fontWeight) return;
      a.setAttribute('data-a11y-inline', '');
    });
  }

  // FAQ blocks: collapsed answers (max-height:0) were still read; hide them while closed
  function initFaqPanels() {
    document.querySelectorAll('[class^="ai-faq-question-"]:not([data-a11y-faq])').forEach(function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      btn.setAttribute('data-a11y-faq', '');
      btn.setAttribute('aria-controls', ensureId(panel, 'a11y-faq-panel'));
      var sync = function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        panel.inert = !open;
        if (open) panel.removeAttribute('aria-hidden');
        else panel.setAttribute('aria-hidden', 'true');
      };
      sync();
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
  }

  // Carousels
  function cellVisible(flkty, cell) {
    if (flkty.options.fade) return cell.element.classList.contains('is-selected');
    var view = flkty.viewport.getBoundingClientRect();
    var rect = cell.element.getBoundingClientRect();
    var overlap = Math.min(rect.right, view.right) - Math.max(rect.left, view.left);
    return overlap > rect.width / 2;
  }

  function setTabbable(cell, on) {
    cell.querySelectorAll(FOCUSABLE + ', [data-a11y-ti]').forEach(function (el) {
      if (on) {
        if (!el.hasAttribute('data-a11y-ti')) return;
        var original = el.getAttribute('data-a11y-ti');
        if (original) el.setAttribute('tabindex', original);
        else el.removeAttribute('tabindex');
        el.removeAttribute('data-a11y-ti');
      } else if (!el.hasAttribute('data-a11y-ti')) {
        el.setAttribute('data-a11y-ti', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      }
    });
  }

  function slideLabel(index, total) {
    return (index + 1) + ' / ' + total;
  }

  function thumbLabel(main, index, total, img) {
    var cell = main && main.cells[index] && main.cells[index].element;
    var heading = cell && cell.querySelector('.yv-banner-title, h1, h2, h3, h4');
    var name = heading ? cleanText(heading) : (img && img.alt ? img.alt : '');
    return 'Show slide ' + (index + 1) + ' of ' + total + (name ? ': ' + name : '');
  }

  function carouselLabel(flkty) {
    if (flkty.navCompanion) return 'Slide thumbnails';
    var section = flkty.element.closest('.shopify-section');
    var heading = section && section.querySelector('h2, h3, .section-heading');
    var text = heading ? cleanText(heading) : '';
    return text && !flkty.element.contains(heading) ? text : 'Featured slides';
  }

  function updateSlider(flkty) {
    var isNav = !!flkty.navCompanion;
    var total = flkty.cells.length;
    if (flkty.element.hasAttribute('data-a11y-label')) flkty.element.setAttribute('aria-label', carouselLabel(flkty));
    flkty.cells.forEach(function (cell, i) {
      var el = cell.element;
      var visible = cellVisible(flkty, cell);
      if ((isNav || el.classList.contains('gallery-thumbs-item')) && !el.querySelector(FOCUSABLE)) {
        var img = el.querySelector('img[alt]');
        el.setAttribute('role', 'button');
        var selected = el.classList.contains('is-nav-selected');
        if (isNav) el.setAttribute('aria-label', thumbLabel(flkty.navCompanion, i, total, img) + (selected ? ', selected' : ''));
        else if (!cleanText(el)) el.setAttribute('aria-label', img && img.alt ? img.alt : slideLabel(i, total));
        el.setAttribute('data-a11y-thumb', String(i));
        el.setAttribute('tabindex', visible ? '0' : '-1');
        if (selected && !isNav) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
        el.removeAttribute('aria-hidden');
        return;
      }
      el.setAttribute('role', 'group');
      el.setAttribute('aria-roledescription', 'slide');
      el.setAttribute('aria-label', slideLabel(i, total));
      if (el.getAttribute('tabindex') === '0') el.setAttribute('tabindex', '-1');
      if (visible) el.removeAttribute('aria-hidden');
      else el.setAttribute('aria-hidden', 'true');
      setTabbable(el, visible);
    });

    flkty.element.querySelectorAll('.flickity-page-dots .dot').forEach(function (dot, i) {
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');
      dot.setAttribute('data-a11y-dot', String(i));
      if (dot.classList.contains('is-selected')) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function focusSelected(flkty) {
    setTimeout(function () {
      var cell = flkty.selectedElement;
      if (!cell) return;
      if (!cell.hasAttribute('tabindex')) cell.setAttribute('tabindex', '-1');
      cell.focus({ preventScroll: true });
    }, 400);
  }

  function initSliders() {
    if (typeof Flickity === 'undefined') return;
    document.querySelectorAll('.flickity-enabled').forEach(function (el) {
      var flkty = Flickity.data(el);
      if (!flkty) return;
      if (!flkty.__a11y) {
        flkty.__a11y = true;
        if (!el.getAttribute('role')) el.setAttribute('role', 'group');
        el.setAttribute('aria-roledescription', 'carousel');
        if (el.getAttribute('role') === 'group' && !el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) el.setAttribute('data-a11y-label', '');
        flkty.on('select', function () { updateSlider(flkty); });
        flkty.on('settle', function () { updateSlider(flkty); });
        if (flkty.options.fade) {
          // Faded-out slides (opacity 0) also get visibility:hidden so checkers skip them
          var markFaded = function () {
            flkty.cells.forEach(function (cell) {
              if (cell.element === flkty.selectedElement) cell.element.removeAttribute('data-a11y-faded');
              else cell.element.setAttribute('data-a11y-faded', '');
            });
          };
          var unmarkAll = function () {
            flkty.cells.forEach(function (cell) { cell.element.removeAttribute('data-a11y-faded'); });
          };
          flkty.on('select', function () { if (flkty.selectedElement) flkty.selectedElement.removeAttribute('data-a11y-faded'); });
          flkty.on('dragStart', unmarkAll);
          flkty.on('settle', markFaded);
          markFaded();
        }
        el.addEventListener('click', function (event) {
          var thumb = event.target.closest('[data-a11y-thumb]');
          if (thumb && flkty.navCompanion) return selectThumb(flkty, thumb);
          if (!event.target.closest('.flickity-prev-next-button')) return;
          setTimeout(function () { announce(slideLabel(flkty.selectedIndex, flkty.slides.length)); }, 50);
        });
      }
      updateSlider(flkty);
    });

    document.querySelectorAll('[data-a11y-ti]').forEach(function (el) {
      if (!el.closest('.flickity-enabled')) {
        var original = el.getAttribute('data-a11y-ti');
        if (original) el.setAttribute('tabindex', original);
        else el.removeAttribute('tabindex');
        el.removeAttribute('data-a11y-ti');
      }
    });
  }

  function activateSliderControl(el) {
    var host = el.closest('.flickity-enabled');
    var flkty = host && typeof Flickity !== 'undefined' && Flickity.data(host);
    if (!flkty) return false;
    if (el.hasAttribute('data-a11y-dot')) {
      flkty.select(Number(el.getAttribute('data-a11y-dot')));
      focusSelected(flkty);
      return true;
    }
    if (el.hasAttribute('data-a11y-thumb') && flkty.navCompanion) {
      selectThumb(flkty, el);
      return true;
    }
    return false;
  }

  // Hero thumbnails: select on activation and announce
  function selectThumb(flkty, thumb) {
    var index = Number(thumb.getAttribute('data-a11y-thumb'));
    var main = flkty.navCompanion;
    main.select(index);
    var heading = main.cells[index] && main.cells[index].element.querySelector('.yv-banner-title, h1, h2, h3, h4');
    announce('Slide ' + (index + 1) + ' of ' + main.cells.length + ' selected' + (heading ? ': ' + cleanText(heading) : ''));
  }

  // Theme selects the slide when a thumbnail gets focus; only change it on click / Enter / Space
  document.addEventListener('focus', function (event) {
    var t = event.target;
    if (t && t.classList && t.classList.contains('flickity-slider-thumb-item')) event.stopPropagation();
  }, true);

  function focusImage(thumb) {
    var image = document.getElementById(thumb.getAttribute('data-image'));
    if (!image) return;
    setTimeout(function () {
      if (!image.hasAttribute('tabindex')) image.setAttribute('tabindex', '-1');
      image.focus({ preventScroll: true });
    }, 450);
  }

  function initThumbs() {
    var thumbs = document.querySelectorAll('.gallery-thumbs-item');
    var total = thumbs.length;
    thumbs.forEach(function (thumb, i) {
      if (thumb.closest('.flickity-enabled') && thumb.hasAttribute('data-a11y-thumb')) return;
      if (!thumb.hasAttribute('data-a11y-btn')) {
        var img = thumb.querySelector('img[alt]');
        markButton(thumb, img && img.alt ? img.alt : slideLabel(i, total));
      }
      if (thumb.classList.contains('active')) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }

  // Links
  var EXTERNAL_TAB = 'Redirecting to a third-party website, opens in a new tab';
  var NEW_TAB = 'Opens in a new tab';
  var NEW_TAB_RE = /\s*\((Opens in a new (window|tab)|Redirecting to a third-party website, opens in a new tab)\.?\)/i;

  function newTabText(a) {
    var label = a.getAttribute('aria-label') || '';
    var m = label.match(NEW_TAB_RE);
    if (m) return m[0];
    var sr = Array.prototype.filter.call(a.querySelectorAll('[data-a11y-text]'), function (n) { return NEW_TAB_RE.test(n.textContent); })[0];
    return sr ? sr.textContent : '';
  }

  // Sentence around a vague link ("Locate a store near you here.")
  function linkSentence(a) {
    var block = a.closest('p, li, td, dd, h1, h2, h3, h4, h5, h6') || a.parentElement;
    if (!block) return '';
    var clone = block.cloneNode(true);
    clone.querySelectorAll('[data-a11y-text]').forEach(function (n) { n.remove(); });
    var path = [];
    for (var x = a; x && x !== block; x = x.parentElement) path.unshift(Array.prototype.indexOf.call(x.parentElement.children, x));
    var target = clone;
    path.forEach(function (i) { target = target && target.children[i]; });
    if (!target) return '';
    var mark = '\u0001';
    target.textContent = mark + cleanText(a) + mark;
    var text = clone.textContent.replace(/\s+/g, ' ');
    var start = text.indexOf(mark);
    var end = text.lastIndexOf(mark);
    var before = text.slice(0, start);
    var after = text.slice(end + 1);
    var s = Math.max(before.lastIndexOf('. '), before.lastIndexOf('! '), before.lastIndexOf('? '));
    var e = after.search(/[.!?](\s|$)/);
    var sentence = (before.slice(s + 1) + text.slice(start + 1, end) + (e === -1 ? after : after.slice(0, e))).trim();
    return sentence.length > cleanText(a).length && sentence.length <= 140 ? sentence : '';
  }

  function initLinks() {
    // "here" / "click here": name the link with its sentence
    document.querySelectorAll('a[href]:not([data-a11y-here])').forEach(function (a) {
      var text = cleanText(a);
      if (!/^(click )?here$/i.test(text)) return;
      a.setAttribute('data-a11y-here', '');
      var sentence = linkSentence(a);
      if (sentence) a.setAttribute('aria-label', sentence + (newTabText(a) ? ' ' + newTabText(a).trim() : ''));
    });

    // Empty links that repeat a neighbouring link (no text, no image)
    document.querySelectorAll('a[href]:not([data-a11y-empty])').forEach(function (a) {
      a.setAttribute('data-a11y-empty', '');
      if (a.getAttribute('aria-label') || a.getAttribute('aria-labelledby') || a.getAttribute('title') || a.textContent.trim() || a.querySelector('img, svg, picture, video, [aria-label]')) return;
      a.setAttribute('aria-hidden', 'true');
      a.setAttribute('tabindex', '-1');
    });

    // Email / phone links: "Email Address: …" / "Phone number: …"
    document.querySelectorAll('a[href^="mailto:" i]:not([data-a11y-contact]), a[href^="tel:" i]:not([data-a11y-contact])').forEach(function (a) {
      a.setAttribute('data-a11y-contact', '');
      if (a.closest('.klaviyo-form, [class*="jdgm"], [class*="appstle"]')) return;
      var href = a.getAttribute('href');
      var isMail = /^mailto:/i.test(href);
      var text = cleanText(a);
      if (!text) {
        try { text = decodeURIComponent(href.replace(/^(mailto|tel):/i, '').split('?')[0]); } catch (e) { text = href.replace(/^(mailto|tel):/i, '').split('?')[0]; }
      }
      a.setAttribute('aria-label', (isMail ? 'Email Address: ' : 'Phone number: ') + text.trim());
    });

    document.querySelectorAll('a[target="_blank"]:not([data-a11y-nw])').forEach(function (a) {
      a.setAttribute('data-a11y-nw', '');
      var external = /^https?:$/.test(a.protocol) && !isInternal(a);
      var suffix = ' (' + (external ? EXTERNAL_TAB : NEW_TAB) + ')';
      var label = a.getAttribute('aria-label');
      if (label) {
        a.setAttribute('aria-label', label + suffix);
        return;
      }
      if (cleanText(a)) {
        a.appendChild(srOnly(suffix));
        return;
      }
      var img = a.querySelector('img[alt]');
      var name = a.getAttribute('title') || (img && img.alt);
      if (name) a.setAttribute('aria-label', name + suffix);
    });

    document.querySelectorAll('a[href]:not([data-a11y-purpose])').forEach(function (a) {
      a.setAttribute('data-a11y-purpose', '');
      if (a.hasAttribute('aria-label')) return;
      var text = cleanText(a);
      if (PDF_LINK.test(text)) {
        var section = a.closest('.shopify-section, section');
        var sh = section && section.querySelector('h1, h2, h3, [role="heading"]');
        var topic = sh && cleanText(sh);
        if (topic) a.appendChild(srOnly(/download/i.test(topic) ? ': ' + topic.replace(/^download\s*/i, '') : ': ' + topic));
        return;
      }
      if (!(VAGUE_LINK.test(text) || (S.readMore && text.toLowerCase() === S.readMore.toLowerCase()))) return;
      var card = a.closest('article, .yv-blog-card') || a.closest('[class*="card"], li');
      if (card && !card.querySelector('h1, h2, h3, h4, h5, h6, [class*="title"], img[alt]:not([alt=""])') && card.parentElement) card = card.parentElement;
      var heading = card && card.querySelector('h1, h2, h3, h4, h5, h6, [class*="title"]');
      var title = heading && cleanText(heading);
      var cardImg = card && card.querySelector('img[alt]:not([alt=""])');
      if (!title && cardImg) title = cardImg.alt.trim();
      if (title && title !== text) a.appendChild(srOnly(': ' + title));
    });
  }

  function initZoomLinks() {
    document.querySelectorAll('.gallery-main-item a[data-thumb]:not([data-a11y-zoom])').forEach(function (a) {
      a.setAttribute('data-a11y-zoom', '');
      a.setAttribute('aria-haspopup', 'dialog');
      var label = a.getAttribute('aria-label');
      if (label) a.setAttribute('aria-label', 'Zoom image: ' + label);
    });
  }

  // Product cards
  function initCards() {
    document.querySelectorAll('.yv-product-card-img:not([data-a11y-card])').forEach(function (img) {
      img.setAttribute('data-a11y-card', '');
      var card = img.closest('.yv-product-card') || img.parentElement;
      var titleEl = card && card.querySelector('.yv-product-title');
      var title = titleEl ? cleanText(titleEl) : '';
      img.querySelectorAll('.quickView[tabindex="-1"], .Sd_addProduct[tabindex="-1"]').forEach(function (btn) {
        btn.removeAttribute('tabindex');
        var base = btn.getAttribute('aria-label') || '';
        if (title && base.indexOf(title) === -1) btn.setAttribute('aria-label', base + ': ' + title);
      });
      img.querySelectorAll('.quickView[role="button"]').forEach(function (link) { link.setAttribute('data-a11y-space', ''); });
      img.querySelectorAll('quick-add-toggle[tabindex="-1"]').forEach(function (toggle) {
        var base = toggle.getAttribute('aria-label') || '';
        markButton(toggle, title && base.indexOf(title) === -1 ? base + ': ' + title : base);
      });
    });
  }

  // Icon-only buttons with no name
  function initCardArrows() {
    document.querySelectorAll('.slider-button-prev:not([aria-label]), .slider-button-next:not([aria-label])').forEach(function (btn) {
      var card = btn.closest('.yv-product-card');
      var titleEl = card && card.querySelector('.yv-product-title');
      var title = titleEl ? cleanText(titleEl) : '';
      var action = btn.classList.contains('slider-button-prev') ? 'Previous image' : 'Next image';
      btn.setAttribute('aria-label', title ? action + ': ' + title : action);
      var svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('aria-hidden', 'true');
    });
    [['.close-sort', 'Close sort'], ['.close-filter', 'Close filters']].forEach(function (pair) {
      document.querySelectorAll(pair[0] + ':not([aria-label])').forEach(function (btn) {
        if (!cleanText(btn)) btn.setAttribute('aria-label', pair[1]);
      });
    });
  }

  // Contrast: the editor green (#5f7f5c) is 4.49:1 with white, darken it just enough
  var GREEN = '#5f7f5c';
  var GREEN_RGB = 'rgb(95, 127, 92)';
  var GREEN_BG = '#5c7c59';
  var GREEN_TEXT = '#567653';
  var contrastSheet = null;
  var contrastDone = {};

  function contrastRule(rule) {
    if (contrastDone[rule]) return;
    contrastDone[rule] = true;
    if (!contrastSheet) {
      contrastSheet = document.createElement('style');
      contrastSheet.setAttribute('data-a11y-contrast', '');
      document.head.appendChild(contrastSheet);
    }
    contrastSheet.appendChild(document.createTextNode(rule + '\n'));
  }

  var BG_FIXES = {
    'rgb(123, 151, 119)': '#5c7c59', // #7b9777 3.21:1 -> 4.69:1 (CTA buttons)
    'rgb(110, 147, 81)': '#5e7e45' // #6e9351 3.53:1 -> 4.62:1 (product card CTA)
  };

  var TEXT_FIXES = {
    'rgb(173, 154, 190)': '#876ba0', // #ad9abe 2.58:1 -> 4.53:1
    'rgb(123, 151, 119)': '#5c7c59', // #7b9777 3.21:1 -> 4.69:1
    'rgb(101, 124, 97)': '#567653', // #657c61 4.29:1 on cream -> 4.81:1 (ingredient carousel headlines)
    'rgb(94, 125, 91)': '#567653' // #5e7d5b 4.47:1 on cream -> 4.96:1 (blog card dates)
  };

  function fixContrast() {
    // Secondary buttons: setting colour #7b9777 with white text is 3.21:1
    var rootStyle = document.documentElement.style;
    ['--colorBtnSecondary', '--colorBtnSecondaryBorder'].forEach(function (v) {
      if (!rootStyle.getPropertyValue(v) && getComputedStyle(document.documentElement).getPropertyValue(v).trim().toLowerCase() === '#7b9777') rootStyle.setProperty(v, '#5c7c59');
    });
    document.querySelectorAll('.button:not([data-a11y-contrast])').forEach(function (btn) {
      btn.setAttribute('data-a11y-contrast', '');
      var style = getComputedStyle(btn);
      ['--colorBtnPrimary', '--colorBtnPrimaryBorder'].forEach(function (v) {
        if (style.getPropertyValue(v).trim().toLowerCase() === GREEN) btn.style.setProperty(v, GREEN_BG);
      });
    });
    document.querySelectorAll('.shopify-section[id]:not([data-a11y-contrast])').forEach(function (section) {
      section.setAttribute('data-a11y-contrast', '');
      if (getComputedStyle(section).backgroundColor === GREEN_RGB) contrastRule('#' + CSS.escape(section.id) + '{background-color:' + GREEN_BG + '!important}');
    });
    document.querySelectorAll('[class^="ai-"]:not([data-a11y-contrast])').forEach(function (el) {
      el.setAttribute('data-a11y-contrast', '');
      var cls = el.classList[0];
      var style = getComputedStyle(el);
      if (style.backgroundColor === GREEN_RGB) contrastRule('.' + cls + '.' + cls + ':not(:hover){background-color:' + GREEN_BG + '}');
      if (style.color === GREEN_RGB) contrastRule('.' + cls + '.' + cls + '{color:' + GREEN_TEXT + '}');
      // Light text colours from section blocks (product page): darker shade of the same hue
      if (TEXT_FIXES[style.color]) contrastRule('.' + cls + '.' + cls + ':not(:hover){color:' + TEXT_FIXES[style.color] + '}');
      if (BG_FIXES[style.backgroundColor]) contrastRule('.' + cls + '.' + cls + ':not(:hover){background-color:' + BG_FIXES[style.backgroundColor] + '}');
      // Blog card dates set to white on a light card (invisible)
      if (/^ai-blog-date-/.test(cls) && style.color === 'rgb(255, 255, 255)') contrastRule('.' + cls + '.' + cls + '{color:#567653 !important}');
    });
  }

  // Cart drawer and quantity
  var lastQty = null;

  function cartTotal() {
    var total = document.querySelector('[data-side-drawer] .totle-price strong');
    return total ? cleanText(total) : '';
  }

  function cartLabel(n) {
    var base = (document.querySelector('.cart-icon') || {}).title || 'Cart';
    return base + ' (' + n + (n === 1 ? ' item' : ' items') + ')';
  }

  function syncCartLabel() {
    var cartLink = document.querySelector('.cart-icon');
    if (!cartLink) return;
    var count = cartLink.querySelector('[data-cart-count]');
    var n = count && count.style.display !== 'none' ? parseInt(cleanText(count), 10) || 0 : 0;
    var label = cartLabel(n);
    if (cartLink.getAttribute('aria-label') !== label) cartLink.setAttribute('aria-label', label);
  }

  var pendingRemove = null;

  function initCartControls() {
    var cartLink = document.querySelector('.cart-icon');
    if (cartLink) {
      syncCartLabel();
      if (cartLink.classList.contains('openCartDrawer') && !cartLink.hasAttribute('data-a11y-space')) {
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('data-a11y-space', '');
        var count = cartLink.querySelector('[data-cart-count]');
        if (count) new MutationObserver(syncCartLabel).observe(count, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      }
    }

    document.querySelectorAll('.cartDrawerNote:not([data-a11y-note])').forEach(function (btn) {
      btn.setAttribute('data-a11y-note', '');
      var sync = function () { btn.setAttribute('aria-expanded', btn.classList.contains('active') ? 'true' : 'false'); };
      sync();
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['class'] });
    });

    // Drawer re-rendered after a quantity change
    if (lastQty && !lastQty.btn.isConnected && document.body.classList.contains('side_Drawer_open')) {
      var again = document.querySelector('[data-side-drawer] .quantity-button.' + lastQty.dir + '[data-line="' + lastQty.line + '"]');
      if (again) {
        again.focus();
        var input = again.closest('.quantity').querySelector('input');
        if (input) announce('Quantity updated to ' + input.value + '. Cart total ' + cartTotal());
      }
      lastQty = null;
    }

    // Drawer re-rendered after a remove
    if (pendingRemove && !pendingRemove.btn.isConnected && document.body.classList.contains('side_Drawer_open')) {
      var lines = document.querySelectorAll('[data-side-drawer] .cart-items-wrapper [data-line] .yv-product-title');
      var target = lines[pendingRemove.index] || lines[pendingRemove.index - 1];
      if (!target) target = document.querySelector('[data-side-drawer] .emptySideCart a, [data-side-drawer] [data-drawer-title]');
      if (target) {
        if (!target.matches(FOCUSABLE)) target.setAttribute('tabindex', '-1');
        target.focus();
      }
      var total = cartTotal();
      announce(pendingRemove.title + ' removed from cart.' + (total ? ' Cart total ' + total : ' Your cart is empty.'));
      pendingRemove = null;
    }
  }

  function onRemoveClick(btn) {
    var row = btn.closest('.media-link');
    var rows = Array.from(document.querySelectorAll('[data-side-drawer] .cart-items-wrapper .media-link'));
    var title = row && row.querySelector('.yv-product-title');
    pendingRemove = { btn: btn, index: rows.indexOf(row), title: title ? cleanText(title) : '' };
  }

  function onQuantityClick(btn) {
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    if (btn.closest('[data-side-drawer]')) {
      lastQty = { btn: btn, line: btn.getAttribute('data-line'), dir: btn.classList.contains('quantity-down') ? 'quantity-down' : 'quantity-up' };
      return;
    }
    setTimeout(function () { announce(S.quantity + ': ' + input.value); }, 150);
  }

  // Search drawer combobox: expanded state and result count
  function initSearchCombobox() {
    var input = document.getElementById('search-drawer-query-input');
    var results = document.getElementById('SearchDrawerResults');
    if (!input || !results || results.hasAttribute('data-a11y-combo')) return;
    results.setAttribute('data-a11y-combo', '');
    var last = null;
    new MutationObserver(function () {
      var count = results.querySelector('[data-a11y-result-count]');
      var hasResults = !!count && parseInt(count.getAttribute('data-a11y-result-count'), 10) > 0;
      input.setAttribute('aria-expanded', hasResults ? 'true' : 'false');
      if (!count) { last = null; return; }
      var n = parseInt(count.getAttribute('data-a11y-result-count'), 10) || 0;
      var message = n ? n + (n === 1 ? ' result found' : ' results found') : 'No results found';
      if (message + input.value !== last) announce(message);
      last = message + input.value;
    }).observe(results, { childList: true });
  }

  // Cart page shipping estimate result
  function initShippingEstimate() {
    var box = document.getElementById('ShippingWrapperResponse');
    if (!box || box.hasAttribute('data-a11y-status')) return;
    box.setAttribute('data-a11y-status', '');
    new MutationObserver(function () {
      var text = cleanText(box);
      if (text) announce(text);
    }).observe(box, { childList: true, subtree: true });
  }

  // Gallery carousel Previous/Next
  function initGalleryNav() {
    document.querySelectorAll('.a11y-gallery-frame:not([data-a11y-gallery])').forEach(function (frame) {
      frame.setAttribute('data-a11y-gallery', '');
      var wrapper = frame.querySelector('.gallery-section-wrapper');
      var outer = frame.querySelector('.yv-gallery-outer');
      var prev = frame.querySelector('.a11y-gallery-prev');
      var next = frame.querySelector('.a11y-gallery-next');
      if (!wrapper || !outer || !prev || !next) return;
      var items = function () { return Array.from(outer.querySelectorAll('.yv-gallery-item')); };

      var update = function () {
        var list = items();
        if (!list.length) return;
        var box = frame.getBoundingClientRect();
        var first = list[0].getBoundingClientRect();
        var last = list[list.length - 1].getBoundingClientRect();
        var img = list[0].querySelector('.yv-gallery-img');
        if (img) {
          var r = img.getBoundingClientRect();
          frame.style.setProperty('--a11y-gallery-mid', (r.top - box.top + r.height / 2) + 'px');
        }
        var hadFocus = document.activeElement;
        prev.hidden = first.left >= box.left - 1;
        next.hidden = last.right <= box.right + 1;
        if (hadFocus === prev && prev.hidden && !next.hidden) next.focus();
        if (hadFocus === next && next.hidden && !prev.hidden) prev.focus();
      };

      var move = function (dir) {
        var step = (items()[0] || outer).getBoundingClientRect().width * dir;
        var scroller = /(auto|scroll)/.test(getComputedStyle(outer).overflowX) ? outer : wrapper;
        var before = scroller.scrollLeft;
        scroller.scrollBy({ left: step, behavior: 'smooth' });
        if (scroller === outer && scroller.scrollLeft === before && outer.scrollWidth <= outer.clientWidth) wrapper.scrollBy({ left: step, behavior: 'smooth' });
        setTimeout(update, 450);
      };

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
      outer.addEventListener('scroll', update, { passive: true });
      wrapper.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Homepage content blocks and footer links
  function initContentFixes() {
    // Placeholder alt text ("Card 1 image") is not a description
    document.querySelectorAll('img[alt]').forEach(function (img) {
      if (/^Card \d+ image$/i.test(img.alt)) img.alt = '';
    });

    // Tab icons are decorative, the tab text names the tab
    document.querySelectorAll('.yv-tab-link img:not([alt])').forEach(function (img) { img.alt = ''; });

    // Image link that repeats the section's call to action
    document.querySelectorAll('[class^="ai-two-column-layout__right-link-"]').forEach(function (link) {
      var section = link.closest('.shopify-section');
      var cta = section && Array.from(section.querySelectorAll('a')).find(function (a) {
        return a !== link && a.getAttribute('href') === link.getAttribute('href') && cleanText(a);
      });
      if (!cta) return;
      var duplicate = isVisible(cta);
      link.setAttribute('aria-label', cleanText(cta));
      if (duplicate) {
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-hidden', 'true');
      } else {
        link.removeAttribute('tabindex');
        link.removeAttribute('aria-hidden');
      }
    });

    initTestimonials();
    fixFooterLinks();
    fixLearnMoreLinks();
  }

  // "Learn More →" links: name the topic from the link title, hide the arrow, same tab for internal pages
  function fixLearnMoreLinks() {
    document.querySelectorAll('a[title]:not([data-a11y-learn])').forEach(function (a) {
      if (!/^learn more\s*[→➜]?$/i.test(cleanText(a))) return;
      a.setAttribute('data-a11y-learn', '');
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        var m = node.textContent.match(/^([\s\S]*?)\s*([→➜])\s*$/);
        if (!m) return;
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = ' ' + m[2];
        node.textContent = m[1];
        node.parentNode.insertBefore(arrow, node.nextSibling);
      });
      var topic = a.getAttribute('title').split(':').pop().trim();
      if (topic) a.appendChild(srOnly(' about ' + topic));
      if (a.target === '_blank' && isInternal(a)) {
        a.removeAttribute('target');
        a.querySelectorAll('[data-a11y-text]').forEach(function (n) { if (NEW_TAB_RE.test(n.textContent)) n.remove(); });
      }
    });
  }

  function initTestimonials() {
    document.querySelectorAll('[class^="ai-testimonial-carousel-"]').forEach(function (root) {
      root.querySelectorAll('[class*="ai-testimonial-carousel__stars-"]:not([role])').forEach(function (stars) {
        var n = stars.querySelectorAll('svg').length;
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', 'Rated ' + n + ' out of 5 stars');
        stars.querySelectorAll('svg').forEach(function (svg) {
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('focusable', 'false');
        });
      });

      var track = root.querySelector('[class*="ai-testimonial-carousel__track-"]');
      if (!track) return;
      var real = Array.from(track.children).filter(function (slide) { return !slide.hasAttribute('data-carousel-clone'); });
      var total = real.length;
      track.querySelectorAll('[data-carousel-clone]').forEach(function (clone) {
        clone.setAttribute('aria-hidden', 'true');
        setTabbable(clone, false);
      });
      real.forEach(function (slide, i) {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', (i + 1) + ' of ' + total);
      });

      if (root.hasAttribute('data-a11y-carousel')) return;
      root.setAttribute('data-a11y-carousel', '');
      root.setAttribute('role', 'region');
      root.setAttribute('aria-roledescription', 'carousel');
      root.setAttribute('aria-label', 'Customer testimonials');
      var trackId = ensureId(track, 'a11y-testimonials');
      root.querySelectorAll('[class*="ai-testimonial-carousel__prev-"], [class*="ai-testimonial-carousel__next-"]').forEach(function (btn) {
        btn.setAttribute('aria-controls', trackId);
        btn.addEventListener('click', function () {
          setTimeout(function () {
            var view = (track.parentElement || root).getBoundingClientRect();
            var current = real.findIndex(function (slide) {
              var r = slide.getBoundingClientRect();
              return r.left >= view.left - 2 && r.left < view.right;
            });
            if (current > -1) announce('Testimonial ' + (current + 1) + ' of ' + total);
          }, 700);
        });
      });
    });
  }

  function isInternal(a) {
    if (!/^https?:$/.test(a.protocol)) return false;
    var canonical = document.querySelector('link[rel="canonical"]');
    var home = canonical ? new URL(canonical.href).host : location.host;
    return a.host === location.host || a.host === home;
  }

  function fixFooterLinks() {
    document.querySelectorAll('.a11y-footer-landmark a[href]:not([data-a11y-footer])').forEach(function (a) {
      a.setAttribute('data-a11y-footer', '');
      // "|" separators are visual only
      Array.from(a.childNodes).forEach(function (node) {
        if (node.nodeType !== 3 || node.textContent.indexOf('|') === -1) return;
        var frag = document.createDocumentFragment();
        node.textContent.split('|').forEach(function (part, i) {
          if (i) {
            var bar = document.createElement('span');
            bar.setAttribute('aria-hidden', 'true');
            bar.textContent = '|';
            frag.appendChild(bar);
          }
          if (part) frag.appendChild(document.createTextNode(part));
        });
        a.replaceChild(frag, node);
      });
      // Internal pages open in the same tab
      if (a.target === '_blank' && isInternal(a)) {
        a.removeAttribute('target');
        a.querySelectorAll('[data-a11y-text]').forEach(function (n) { if (NEW_TAB_RE.test(n.textContent)) n.remove(); });
        var label = a.getAttribute('aria-label');
        if (label && NEW_TAB_RE.test(label)) a.setAttribute('aria-label', label.replace(NEW_TAB_RE, ''));
      }
    });
  }

  // Collection sort: arrows only move, Enter/Space applies
  var pendingSort = null;

  function sortButton() { return document.querySelector('.collection-sortby-selected'); }

  function initSort() {
    var btn = sortButton();
    var list = document.getElementById('sort__list');
    if (!btn || !list) return;
    if (!btn.hasAttribute('data-a11y-sort')) {
      btn.setAttribute('data-a11y-sort', '');
      btn.setAttribute('aria-controls', 'sort__list');
      var sync = function () { btn.setAttribute('aria-expanded', list.classList.contains('active') ? 'true' : 'false'); };
      sync();
      new MutationObserver(sync).observe(list, { attributes: true, attributeFilter: ['class'] });
    }
    if (pendingSort && !pendingSort.btn.isConnected) {
      btn.focus();
      var count = document.querySelector('.products-count');
      announce('Sorted by ' + pendingSort.label + '.' + (count ? ' ' + cleanText(count) : ''));
      pendingSort = null;
    }
  }

  document.addEventListener('keydown', function (event) {
    var radio = event.target.closest && event.target.closest('[data-sort-by]');
    var list = document.getElementById('sort__list');
    if (radio) {
      var radios = Array.from(document.querySelectorAll('[data-sort-by]'));
      var i = radios.indexOf(radio);
      var step = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
      if (step) {
        event.preventDefault();
        event.stopPropagation();
        radios[(i + step + radios.length) % radios.length].focus();
        return;
      }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        if (radio.checked) return;
        pendingSort = { btn: sortButton(), label: radio.getAttribute('data-name') || cleanText(radio.parentElement) };
        radio.click();
        return;
      }
    }
    if (event.key === 'Escape' && list && list.classList.contains('active') && list.contains(event.target)) {
      var btn = sortButton();
      if (btn) { btn.click(); btn.focus(); }
    }
  }, true);

  document.addEventListener('click', function (event) {
    var radio = event.target.closest && event.target.closest('label[for^="sortByOption-"]');
    if (!radio || pendingSort) return;
    var input = document.getElementById(radio.getAttribute('for'));
    if (input && !input.checked) pendingSort = { btn: sortButton(), label: input.getAttribute('data-name') || cleanText(radio) };
  }, true);

  // Product label pop-up
  function initLabelModal() {
    document.querySelectorAll('[data-label-modal]:not([data-a11y-modal])').forEach(setupLabelModal);
  }

  function setupLabelModal(modal) {
    modal.setAttribute('data-a11y-modal', '');
    var viewer = modal.closest('[data-product-label-viewer]');
    var trigger = viewer && viewer.querySelector('[data-label-open]');
    var image = modal.querySelector('[data-label-image]');
    if (trigger) trigger.setAttribute('aria-haspopup', 'dialog');

    new MutationObserver(function () {
      if (!modal.hidden) {
        var close = modal.querySelector('button[data-label-close]');
        setTimeout(function () { if (close) close.focus(); }, 50);
      } else if (trigger && isVisible(trigger)) {
        trigger.focus();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });

    if (image) {
      new MutationObserver(function () {
        if (!modal.hidden && image.alt) announce(image.alt);
      }).observe(image, { attributes: true, attributeFilter: ['alt'] });
    }
  }

  // Events
  document.addEventListener('focusin', function (event) {
    if (!inDialog(event.target)) lastOutside = event.target;
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target.closest(FOCUSABLE + ', [role="button"]');
    if (target && !inDialog(target)) lastOutside = target;
  }, true);

  // Screen reader clicks don't move the pointer, so the theme treats them as outside clicks
  var INSIDE = '.side-menu, .search-bar-container, .search-form, .yv_side_drawer_wrapper, .yv_similar_drawer_wrapper, .openCartDrawer, .navbar-toggler, .customer-links, #filterSideBar, [data-account-popup], .account-popup';
  ['mousedown', 'mouseup', 'click'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!('mouse_is_inside' in window) || window.mouse_is_inside) return;
      if (!(event.target instanceof Element) || !event.target.closest(INSIDE)) return;
      window.mouse_is_inside = true;
      setTimeout(function () { window.mouse_is_inside = false; }, 0);
    }, true);
  });

  document.addEventListener('click', function (event) {
    var qty = event.target.closest('.quantity-button');
    if (qty) onQuantityClick(qty);
    var remove = event.target.closest('[data-side-drawer] .sd_mini_removeproduct');
    if (remove) onRemoveClick(remove);
    if (event.target.closest('[data-a11y-login-close]')) document.body.classList.remove('account-popup-open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') trapTab(event);

    var target = event.target;
    var isEnter = event.key === 'Enter';
    var isSpace = event.key === ' ';

    if ((isEnter || isSpace) && (target.hasAttribute('data-a11y-dot') || target.hasAttribute('data-a11y-thumb'))) {
      event.preventDefault();
      if (!activateSliderControl(target)) {
        target.click();
        if (target.classList.contains('gallery-thumbs-item')) focusImage(target);
      }
      return;
    }
    if ((isEnter || isSpace) && target.hasAttribute('data-a11y-btn')) {
      event.preventDefault();
      target.click();
      if (target.classList.contains('gallery-thumbs-item')) focusImage(target);
      return;
    }
    if (isSpace && target.hasAttribute('data-a11y-space')) {
      event.preventDefault();
      target.click();
      return;
    }

    if (event.key === 'Escape' && document.body.classList.contains('account-popup-open')) {
      document.body.classList.remove('account-popup-open');
    }
  });

  // Animated GIFs: visible play/pause button (WCAG 2.2.2)
  var GIF_RE = /\.gif(\?|$)/i;
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>';

  function setGifPaused(img, btn, paused) {
    if (paused && !(img.complete && img.naturalWidth)) {
      img.addEventListener('load', function () { setGifPaused(img, btn, true); }, { once: true });
      return;
    }
    var frame = img.__a11yFrame;
    if (paused) {
      // Freeze the current frame on a canvas laid over the image (drawn at screen resolution)
      if (!frame) {
        frame = document.createElement('canvas');
        frame.className = 'a11y-gif-frame';
        frame.setAttribute('aria-hidden', 'true');
        img.__a11yFrame = frame;
      }
      var dpr = window.devicePixelRatio || 1;
      frame.width = Math.max(1, Math.round(img.clientWidth * dpr));
      frame.height = Math.max(1, Math.round(img.clientHeight * dpr));
      // Whole image into a "cover" rectangle (source rects use bitmap pixels, which differ from naturalWidth with srcset)
      var scale = Math.max(frame.width / img.naturalWidth, frame.height / img.naturalHeight);
      var dw = img.naturalWidth * scale;
      var dh = img.naturalHeight * scale;
      var ctx = frame.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, (frame.width - dw) / 2, (frame.height - dh) / 2, dw, dh);
      img.parentNode.insertBefore(frame, img.nextSibling);
      img.style.opacity = '0';
    } else {
      if (frame && frame.parentNode) frame.parentNode.removeChild(frame);
      img.style.opacity = '';
    }
    btn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
    btn.setAttribute('aria-label', paused ? 'Play animated image' : 'Pause animated image');
    btn.setAttribute('data-paused', paused ? 'true' : 'false');
  }

  // Find the card inside the GIF (most have white margins around it). Rows/columns that differ from the corner
  // colour on 20%+ of their length, so near-white cards (beige) count and stray pixels don't
  function measureGifContent(img) {
    var src = img.currentSrc || img.src;
    if (!src || img.__a11yBoxSrc === src) return;
    img.__a11yBoxSrc = src;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var W = 300;
        var H = Math.max(1, Math.round(W * probe.naturalHeight / probe.naturalWidth));
        var c = document.createElement('canvas');
        c.width = W;
        c.height = H;
        var x = c.getContext('2d');
        x.drawImage(probe, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data;
        var cols = new Array(W).fill(0);
        var rows = new Array(H).fill(0);
        for (var yy = 0; yy < H; yy++) {
          for (var xx = 0; xx < W; xx++) {
            var k = (yy * W + xx) * 4;
            if (Math.abs(d[k] - d[0]) + Math.abs(d[k + 1] - d[1]) + Math.abs(d[k + 2] - d[2]) > 20) {
              cols[xx]++;
              rows[yy]++;
            }
          }
        }
        var x1 = -1, y1 = -1;
        for (xx = 0; xx < W; xx++) if (cols[xx] > H * 0.2) x1 = xx;
        for (yy = 0; yy < H; yy++) if (rows[yy] > W * 0.2) y1 = yy;
        if (x1 > 0 && y1 > 0) img.__a11yBox = { x1: (x1 + 1) / W, y1: (y1 + 1) / H };
      } catch (e) {}
      positionGifButton(img);
    };
    probe.src = src;
  }

  // Button sits in the white margin beside the card's lower-right corner, so it covers no content.
  // No room (GIF without margins): inside the image's lower-right corner
  function positionGifButton(img) {
    var btn = img.__a11yGifBtn;
    if (!btn) return;
    var box = img.__a11yBox || { x1: 1, y1: 1 };
    var holder = img.parentElement.getBoundingClientRect();
    var r = img.getBoundingClientRect();
    var iw = img.naturalWidth || r.width;
    var ih = img.naturalHeight || r.height;
    var scale = Math.max(r.width / iw, r.height / ih);
    var right = r.left + (r.width - iw * scale) / 2 + box.x1 * iw * scale;
    var bottom = r.top + (r.height - ih * scale) / 2 + box.y1 * ih * scale;
    var spaceRight = holder.right - Math.min(right, holder.right);
    var spaceBottom = holder.bottom - Math.min(bottom, holder.bottom);
    var size = Math.min(36, Math.floor(spaceRight - 8));
    if (size >= 24) {
      btn.style.width = size + 'px';
      btn.style.height = size + 'px';
      btn.style.right = Math.round((spaceRight - size) / 2) + 'px';
      btn.style.bottom = Math.round(spaceBottom) + 'px';
    } else {
      btn.style.width = '';
      btn.style.height = '';
      btn.style.right = Math.max(12, spaceRight + 12) + 'px';
      btn.style.bottom = Math.max(12, spaceBottom + 12) + 'px';
    }
  }

  var gifResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(gifResizeTimer);
    gifResizeTimer = setTimeout(function () {
      document.querySelectorAll('img[data-a11y-gif]').forEach(function (img) {
        positionGifButton(img);
        if (img.__a11yGifBtn && img.__a11yGifBtn.getAttribute('data-paused') === 'true') setGifPaused(img, img.__a11yGifBtn, true);
      });
    }, 200);
  });

  function initGifs() {
    document.querySelectorAll('img:not([data-a11y-gif])').forEach(function (img) {
      if (!GIF_RE.test(img.currentSrc || img.src || img.getAttribute('data-src') || '')) return;
      if (img.closest('.gallery-thumbs-item, [data-a11y-gif-skip]')) return;
      var rect = img.getBoundingClientRect();
      if (rect.width < 120 || rect.height < 80) {
        if (!img.__a11yGifWait) {
          img.__a11yGifWait = true;
          img.addEventListener('load', function () { img.__a11yGifWait = false; initGifs(); }, { once: true });
        }
        return;
      }
      var holder = img.parentElement;
      img.setAttribute('data-a11y-gif', '');
      if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'a11y-gif-toggle';
      holder.appendChild(btn);
      img.__a11yGifBtn = btn;
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setGifPaused(img, btn, btn.getAttribute('data-paused') !== 'true');
      });
      img.addEventListener('load', function () { measureGifContent(img); positionGifButton(img); });
      measureGifContent(img);
      positionGifButton(img);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setGifPaused(img, btn, false);
      if (reduce) setGifPaused(img, btn, true);
    });
  }

  function refresh() {
    initDialogs();
    initLogin();
    initMainMenu();
    initMobileSubmenus();
    initLandmarks();
    fixHeadings();
    initPromo();
    initTabs();
    initAccordions();
    initFaqPanels();
    initScanFixes();
    initInlineLinks();
    initBlogCards();
    initCards();
    initCardArrows();
    fixContrast();
    initSliders();
    initThumbs();
    initZoomLinks();
    initContentFixes();
    initLinks();
    initCartControls();
    initSearchCombobox();
    initShippingEstimate();
    initGalleryNav();
    initSort();
    initLabelModal();
    initGifs();
  }

  var pending = false;
  function scheduleRefresh() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      refresh();
    });
  }

  // Back to top: show after a short scroll, move focus to the top links on click
  function initBackToTop() {
    var btn = document.getElementById('myBtn');
    var top = document.getElementById('top-back');
    if (!btn) return;
    window.scrollFunction = function () {
      btn.style.display = window.pageYOffset > 200 ? 'flex' : 'none';
    };
    window.scrollFunction();
    if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', btn.getAttribute('title') || 'Back to top');
    btn.querySelectorAll('svg').forEach(function (svg) {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
    btn.addEventListener('click', function () {
      if (top) top.focus({ preventScroll: true });
    });
  }

  function start() {
    refresh();
    initBackToTop();
    onBodyClass();
    new MutationObserver(onBodyClass).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        return !(r.target === live || (live && live.contains(r.target)));
      });
      if (relevant) scheduleRefresh();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', function () {
    refresh();
    setTimeout(refresh, 1500);
  });
})();
